import { useCallback, useMemo, useState } from 'react';
import Checkbox from 'src/components/design-system/Checkbox';
import Image from '../../components/Image';

import useAttachDocument from 'src/hooks/useAttachDocument';
import useWindowSize from 'src/hooks/useWindowSize';
import { validSignedUrl } from 'src/utils/strings';
import DocumentCountTracker from '../../components/DocumentCountTracker';
import PreviewPDF from '../../components/PreviewPDF';

function EnterReceiptPreview() {
  const {
    selectedAttachments,
    setSelectedAttachments,
    count,
    attachmentListData: documents,
    isInvoice,
  } = useAttachDocument();

  const { height, width } = useWindowSize();

  const [currentlyViewed, setCurrentlyViewed] = useState(1);
  const isPDF = documents[currentlyViewed - 1]?.description?.toLowerCase().endsWith('.pdf');

  const onCheck = useCallback(() => {
    let checkedArr: number[] = [...selectedAttachments];
    if (selectedAttachments?.includes(documents[currentlyViewed - 1].attachId))
      checkedArr =
        checkedArr?.filter((num: number) => num !== documents[currentlyViewed - 1].attachId) || [];
    else checkedArr.push(documents[currentlyViewed - 1].attachId);
    setSelectedAttachments([...checkedArr]);
  }, [currentlyViewed, selectedAttachments, setSelectedAttachments, documents]);

  const document = useMemo(() => documents[currentlyViewed - 1], [currentlyViewed, documents]);

  return (
    <>
      <div className="flex justify-center">
        <Checkbox
          label={`Attach to ${isInvoice ? 'invoice' : 'receipt'}`}
          checked={selectedAttachments?.includes(documents[currentlyViewed - 1]?.attachId)}
          onChange={onCheck}
        />
      </div>
      <DocumentCountTracker
        disableDecrement={currentlyViewed <= 1}
        disableIncrement={currentlyViewed >= count}
        currentSelected={count === 0 ? 0 : currentlyViewed}
        total={count}
        decrementFn={() => setCurrentlyViewed((prev) => prev - 1)}
        incrementFn={() => setCurrentlyViewed((prev) => prev + 1)}
      />

      {!isPDF && (
        <Image
          src={`${validSignedUrl(document?.signedUrl)}`}
          controls
          filename={document?.originalFile}
          styles={{
            width: `${width}px`,
            maxHeight: `${height - 210}px`,
          }}
        />
      )}
      {isPDF && (
        <PreviewPDF url={`${validSignedUrl(document?.signedUrl)}`} height={`${height - 180}px`} />
      )}
    </>
  );
}

export default EnterReceiptPreview;
